import { memo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { root } from '~/preloaded';
import { useAppSelector } from '~/store';
import { isClanHubEnabledSelector } from '~/store/selectors/settingsSelector';

import Back from '~/Components/UIKit/Back/Back';

import styles from './NavMenuBack.module.scss';
import NavMenuBackClanHub from './NavMenuBackClanHub';

const NavMenuBack = () => {
  const { clanId, purpose } = useParams();
  const { pathname } = useLocation();

  const isClanHubEnabled = useAppSelector(isClanHubEnabledSelector);

  if (pathname === root) {
    return null;
  }

  const shouldNavigateToRoot = !clanId && !purpose;

  if (shouldNavigateToRoot) {
    if (!isClanHubEnabled) {
      return null;
    }

    return (
      <div className={styles.back}>
        <NavMenuBackClanHub />
      </div>
    );
  }

  return (
    <div className={styles.back}>
      <Back />
    </div>
  );
};

export default memo(NavMenuBack);
